// import axios from 'axios';

export function requestSearch(data) {
    // return axios.request({
    //     method: 'get',
    //     url: API_URL + "properties?populate=*"

    // })
}